<template>
  <div id="alert-group-status-app">
      <v-container class="alert-group-status-container">
        <div :id="vueTableID" :class="vueTableClass" data-app="true">
          <alert-filters
              :breakdowns="breakdowns"
              :button-enabled="false"
              :pref-key="'_' + alertId"
              @alert-filters="updateFilters"
          />
          <vy-table ref="alertGroupStatusTable"
                    :columns="columns"
                    :table-data="tableData"
                    :show-edit="false"
                    :disable-row-selection="true"
                    :filter="filter"
                    layout="fitDataFill"
                    :height="tableHeight"
          />
<!--          todo decide if persistence makes sense-->
<!--          :persistence-i-d="'vyopta_cpmm_table_alert_details_group_' + alertId"-->

          <!--                    @data-loaded="handleDataLoaded"-->
          <!--                    @data-changed="handleDataChanged"-->
          <!--                    @data-filtered="handleDataFiltered"-->
          <!--                    @column-selection="handleColumnSelectionChange"-->
          <!--                    @table-sorted="handleSortChange"-->
          <!--                    @row-click="handleRowClick"-->
        </div>
      </v-container>
  </div>
</template>

<script>
  import _ from 'lodash';
  import UtilsService from "../../../../services/utils.service";
  import VyTable from '../../../../vueComponents/table/src/table.vue';
  import VueDatasetService from "../../../../services/vue-dataset-view.service";
  import AlertFilters from "../moi-filters/alertFilters.vue";

  export default {
    name: 'alert-group-status',
    components: {
      'alert-filters': AlertFilters,
      'vy-table': VyTable
    },
    props: {
      alertId: {
        type: String,
        default: '',
      },
      groupData: {
        type: Array,
        default: function() {
          return [];
        }
      },
      groupBy: {
        type: Array,
        default: function() {
          return [];
        }
      },
      groupByDisplay: {
        type: Array,
        default: function() {
          return [];
        }
      },
    },
    data: function() {
      return {
        // shownColumns: ['status', 'name', 'last_updated'],
        vueTableID: UtilsService.generateID(),
        vueTableClass: 'vue-table-alert-group-statuses',
        mounted: false,
        filter: [],
      };
    },
    computed: {
      tableData: function() {
        let self = this;
        return self.groupData;
      },
      tableHeight: function() {
        let self = this;
        if (self.groupData && self.groupData.length > 1) {
          return Math.min(251, self.groupData.length * 42 + 43);
        }
        return 42 + 43;
      },
      groupByDisplayString: function() {
        let self = this;
        return _.isArray(this.groupByDisplay) ? this.groupByDisplay.join(', ') : this.groupByDisplay;
      },
      columns: function() {
        let self = this;
        return VueDatasetService.convertColumns([
          {
            id: 'status',
            name: 'Status',
            type: 'ALERT_STATE',
            minWidth: 100,
            description: 'The real-time state for the group of the rule. Possible values are \'Clear\', \'Info\', \'Warn\', and \'Critical\' (in ascending severity order).'
          },
          {
            id: 'last_updated',
            name: 'Time Changed',
            type: 'DATE',
            minWidth: 150,
            sort: 'desc',
            description: 'The date and time the rule group status was last changed.'
          },
          {
            id: 'group',
            name: self.groupByDisplayString,
            type: 'GROUP_NICE_NAME',
            minWidth: 350,
            description: 'The group name for the rule.'
          },
          {
            id: 'key',
            name: 'Key',
            type: 'STRING',
            invisible: true
          },
        ]);
      },
      breakdowns: function () {
        let self = this;
        let breakdown = {
          status: {
            Clear: 0,
            Critical: 0,
            Info: 0,
            Warn: 0,
          },
        };
        _.forEach(self.tableData, row => {
          breakdown.status[row.status]++;
        });
        return breakdown;
      }

    },
    created: function() {
      let self = this;
    },
    mounted(){
      let self = this;

      self.mounted = true;

    },
    methods: {
      updateFilters: function(newFilters) {
        let self = this;
        self.filter = newFilters;
      }
    },
    watch: {
    }
  }
</script>

<style lang="scss" scoped>
  div#alert-group-status-app {
    width: 100%;
  }
  
  .alert-group-status-container {
    max-width: unset!important;
    margin-left: 0!important;
    margin-right: 0!important;
    padding-top: 0;
    padding-bottom: 0;

    margin-top: 0;
    height: 100%;
    width: 100%;

    .vy-table-wrapper {
      margin-top: 4px;
    }
  }

</style>
<style lang="scss">
  
  .alert-group-status-container {
    .vue-table-alert-group-statuses .vy-table-wrapper .vy-table.tabulator {
      height: 251px;
      margin-bottom: 0;
    }
  }

</style>
